import { ResponseErrorTypes, ResponseType } from './responseTypes';
import { ErrorDetails } from 'acscp/api/models/errorDetails';

export class Success<T> {
    readonly type: ResponseType.Success = ResponseType.Success;
    constructor(readonly payload: T, readonly headers: Headers) {}
}

export class FatalError {
    readonly type: ResponseType.Fatal = ResponseType.Fatal;
    constructor(public message: string, public details: any) {
    }
}

// Denotes that the API is unavailable for requests. Does not imply that there's a problem with the request itself.
export class ServiceUnavailable {
    readonly type: ResponseType.ServiceUnavailable = ResponseType.ServiceUnavailable;
    constructor(public message: string, public details: any) {
    }
}

export class InsufficientAuth {
    readonly type: ResponseType.InsufficientAuth = ResponseType.InsufficientAuth;
}

export class ResponseError {
    constructor(
        readonly type: ResponseErrorTypes,
        readonly message: string,
        readonly details: ErrorDetails,
        readonly headers: Headers,
    ) {}
}

export type ApiResponse<T> = Success<T> | FatalError | ServiceUnavailable | InsufficientAuth | ResponseError;
